<!-- <template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Login to Continue</h2>
			</div>
		</div>
		
		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<div class="tac">
						<div class="login-box">
							<div class="login-form">

								<form @submit.prevent="onSubmit" novalidate="">
									<div class="form-group">
										<label for="">
											Mobile number or Email
											
										</label>

										<input autocomplete="off" id="username" v-model="vModel.username" v-validate="'required|verify_mobile_email'"
													 data-vv-as='Email or Phone' v-drag-disable=''
													 :class="{'input': true, 'is-danger': errors.has('username'),'form-control' : true  }" type="text"
													 placeholder="Mobile number or Email" data-vv-name="username" />
										<div v-show="errors.has('username')" class="help is-danger">{{ errors.first('username') }}</div>
									</div>

									<div class="form-group">
										<label for="">
											Password
											
										</label>
										<div class="input-group">

											<input autocomplete="off" v-model="vModel.password" data-vv-as='Password' v-drag-disable=''
														 data-vv-name="userpassword" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('userpassword'),'form-control' : true }"
														 :type="showPassword ? 'text' : 'password'"
														 placeholder="Password" />

											<div class="input-group-append toggle-hide" @click="showPassword=!showPassword">
												<span class="input-group-text" id="basic-addon3">{{showPassword ? 'hide' : 'show'}}</span>
											</div>
										</div>
										<div v-show="errors.has('userpassword')" class="help is-danger">{{ errors.first('userpassword') }}</div>
									</div>

									<div class="form-group">
										<button class="btn main-btn">Log in</button>
									</div>
									<div class="row d-none">
										<div class="col-md-6">
											<button class="btn btn-block" @click="auth('google')">Google</button>
										</div>
										<div class="col-md-6">
											<button class="btn btn-block" @click="auth('facebook')">Facebook</button>
										</div>
									</div>
								</form>


								<router-link :to="'forgotpassword'" class="forgot-password">Forgot Your Password?</router-link>
							</div>
							

							<div class="register-here">
								<p>New to eRemit ?</p>
								<router-link :to="'/account/registration/initial'" class="btn signup-btn">Sign Up Now!</router-link>

							</div>
						</div>
					</div>

				</div>
				

			</div>
			
		</div>
		

	</div>

	
</template> -->
<template>
	<div>
		<b-modal v-model="showAfterLogoutModal" id="modal-lg" class="home-modal" size="lg" hide-footer="true" no-close-on-backdrop="true" no-close-on-esc="true" @close="closeClearCacheBanner">
			<img src="/static/commercial/img/img-clear-cache.png" class="banner-img" />
		</b-modal>

		<b-modal v-model="modalShow" id="modal-lg" :class="home-modal" size="lg" hide-footer="true">
			<LoginBanner />
			<!-- <img src="static/commercial/img/MMRemtechAwards.jpg" class="banner-img"  onclick="window.open('https://remtech.org/merchantrade-money-visa-prepaid-card/', '_blank')"> -->
		</b-modal>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Login to Continue</h2>
			</div>
		</div>

		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<form action="" @submit.prevent="$parent.onUserNameSubmit">
						<div class="phrase-content">
							<div class="content-inner">
								<div class="loginToContinue">
									<div class="welcome-text">
										<h4>Welcome !</h4>
										<p>Login to continue </p>
									</div>

									<div class="tab-menu">
										<b-tabs content-class="mt-3" v-model="vModel.tabIndex">
											<b-tab title="Phone Number">
												<div class="row">
													<div class="col-lg-12">


														<div class="input-group">
															<div class="input-group-prepend">
																<span class="input-group-text"><img width="50"
																		src="/static/img/passphrase/my.svg"><span>+60
																	</span></span>
															</div>

															<!-- <input autocomplete="off" id="phone"
															v-model="vModel.Phone"
															v-validate="vModel.tabIndex == 0 ?'required|verify_mobile' : ''"
															data-vv-as='Phone Number' v-drag-disable=''
															:class="{'input': true, 'is-danger': errors.has('phone'),'form-control' : true  }"
															type="text" placeholder="123456789"
															data-vv-name="phone"
															name="phone" />
														<div v-show="errors.has('phone')" class="help is-danger">
															{{ errors.first('phone') }}</div> -->
															<input autocomplete="off" id="phone" v-model="vModel.Phone"
																@keydown="ValidateMobile"
																v-validate="vModel.tabIndex == 0 ?'required' : ''"
																data-vv-as='Phone Number' v-drag-disable=''
																:class="{'input': true, 'is-danger': errors.has('phone'),'form-control' : true  }"
																type="text" placeholder="123456789" data-vv-name="phone"
																name="phone" />
															<div v-show="errors.has('phone')" class="help is-danger">
																{{ errors.first('phone') }}</div>
															<div v-show="!errors.has('phone') && ShowMobileErrorMsg"
																class="help is-danger">
																Invalid Phone Number</div>
														</div>
													</div>
													<!-- eo col -->
												</div>


											</b-tab>
											<b-tab title="Email Address">
												<div class="row">
													<div class="col-lg-12">

														<input autocomplete="off" id="emailaddress" v-model="vModel.Email"
															v-validate="vModel.tabIndex == 1 ?'required|email' : ''"
															data-vv-as='Email Address' v-drag-disable=''
															:class="{'input': true, 'is-danger': errors.has('emailaddress'),'form-control' : true  }"
															type="email" placeholder="example@gmail.com"
														    name="emailaddress" />
														<div v-show="errors.has('emailaddress')" class="help is-danger">
															{{ errors.first('emailaddress') }}</div>


													</div>
													<!-- eo col -->
												</div>


											</b-tab>

										</b-tabs>

									</div>

									<div class="new-signup">
										<p>New ? <router-link :to="'/account/registration/initial'">Signup</router-link>
										</p>

									</div>
								</div>
								<!--end login-to-continue-->
								<div class="button-wrap ">
									<button class="btn btn-next" type="submit">Next</button>
								</div>

							</div>
							<!--end Content inner-->
						</div>
						<!--end content-->
					</form>

				</div>


			</div>

		</div>


	</div>


</template>




<script>
	import LoginBanner from "../../shared/CovidBanner";

	export default {
		name: "loginusername",
		props: ["vModel", "isLoggedOut"],
		inject: ['$validator'],
		components: {
			LoginBanner
		},
		mounted(){
			if (this.$route.params.isLoggedOut){
				this.showAfterLogoutModal = true;
			}
			else{
				this.showBeforeLoginInsureBanner = true;
			}
		},
		data() {
			return {
				modalShow: false,
				ShowMobileErrorMsg: false,
				showAfterLogoutModal: false,
				showBeforeLoginInsureBanner: false,
				isLoggedOut: false
			}
		},
		methods: {
			ValidateMobile(event) {
				var keyCode = event.keyCode ? event.keyCode : event.which;
				var phoneLen = this.vModel.Phone === null ? 0 : this.vModel.Phone.length;
				if ((!(keyCode > 93 && keyCode < 106) && (keyCode < 48 || keyCode > 57)) || phoneLen > 9) {
					event.preventDefault();
				}
				if (keyCode === 8) {
					//on backspace
					this.vModel.Phone = this.vModel.Phone.slice(0, -1);
					if (this.vModel.Phone.length < 9) {
						this.ShowMobileErrorMsg = true;
					}
				} else {
					var len = this.vModel.Phone === null ? 0 : this.vModel.Phone.length;
					if (len < 8) {
						this.ShowMobileErrorMsg = true;
					} else {
						this.ShowMobileErrorMsg = false;
					}
				}
			},
			closeClearCacheBanner: function (evt) {
				this.showAfterLogoutModal = false;
				this.showBeforeLoginInsureBanner = true;
				evt.preventDefault();
			},
		}

	}
</script>
